import { useEffect } from 'react';
import { site } from '@shared/site.config';

/** Same title logic used client-side (here) and by scripts/prerender.mjs via src/lib/routeMeta.ts. */
export function resolveTitle(title: string): string {
  return title ? `${title} — ${site.brand.name}` : `${site.brand.name} — ${site.brand.tagline}`;
}

/**
 * Sets document.title and the meta description per route. This is a client-side
 * SPA, so crawlers that don't execute JS won't see these on their own — that gap
 * is what scripts/prerender.mjs closes at build time.
 */
export function useTitle(title: string, description?: string) {
  useEffect(() => {
    document.title = resolveTitle(title);
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', description);
    }
  }, [title, description]);
}
